<div class="activities-page">

  <div class="activities-card">

    @if (
  currentRole === 'admin' ||
  currentRole === 'student' ||
  (currentRole === 'volunteer' && isVolunteerStatusLoaded)
  ) {

    <!-- ENCABEZADO -->
    <header class="activities-header">
      <div>

        @if (isAdmin) {
          <span class="eyebrow">Administración</span>

          <h1>Gestión de actividades</h1>

          <p>
            Consulta actividades, revisa la participación de estudiantes
            y administra las acciones disponibles.
          </p>
        } @else {
          @if (
            (currentRole === 'volunteer' && volunteerAccountStatus === 'inactive') ||
            (currentRole === 'student' && studentAccountStatus === 'inactive')
          ) {
        
            <span class="eyebrow">Servicio social</span>
        
            <h1>Cuenta de voluntario</h1>
        
            <p>
              Tu cuenta se encuentra actualmente inactiva.
            </p>
        
          } @else {
        
            <span class="eyebrow">Servicio social</span>
        
            <h1>Actividades disponibles</h1>
        
            <p>
              Consulta las actividades disponibles, revisa sus detalles
              y regístrate en las que quieras participar.
            </p>
        
          }
        }

      </div>
    </header>

  }
    @if (
  (currentRole === 'volunteer' && volunteerAccountStatus === 'inactive') ||
  (currentRole === 'student' && studentAccountStatus === 'inactive')
) {

  <div class="inactive-volunteer-state">

    <div class="inactive-volunteer-state-icon">
      🔒
    </div>

    <span class="inactive-volunteer-state-eyebrow">
      CUENTA INACTIVA
    </span>

    <h2>
      Ya no tienes acceso a nuevas actividades
    </h2>

    <p>
      Tu cuenta de voluntario está actualmente inactiva.
      Al haber sido dado de baja, ya no puedes consultar
      ni registrarte en nuevas actividades.
    </p>

  </div>

} @else if (isVolunteerStatusLoaded) {


    <div class="activities-content">

      <!-- BUSCADOR + CONTADOR -->
      <div class="activity-toolbar">

        <div class="search-box">
          <label for="table-filtering-search">
            Buscar actividad
          </label>

          <input
            id="table-filtering-search"
            class="form-control search-input"
            type="text"
            [formControl]="filter"
            placeholder="Título, descripción, tipo, horas o ID..."
          />
        </div>


        <div class="activity-count">
          <span class="count-number">
            {{ filteredData.length }}
          </span>

          <span class="count-label">
            {{
              filteredData.length === 1
                ? 'actividad'
                : 'actividades'
            }}
          </span>
        </div>

      </div>


      <!-- LISTA -->
      <div class="activity-list">

        @for (
          activity of pagedActivities;
          track activity.id;
          let i = $index
        ) {

          <article class="activity-item">

            <!-- NÚMERO -->
            <div class="activity-number">
              {{ i + 1 }}
            </div>


            <!-- INFORMACIÓN -->
            <div class="activity-main">

              <div class="activity-topline">

                <span class="activity-type">
                  {{ activity.type || 'Sin tipo' }}
                </span>

                <span class="activity-hours">
                  {{ activity.valueInHours }} h
                </span>

              </div>


              <h2 class="activity-title">
                <ngb-highlight
                  [result]="activity.title"
                  [term]="filter.value"
                ></ngb-highlight>
              </h2>


              <p class="activity-description">
                <ngb-highlight
                  [result]="activity.description || 'Sin descripción'"
                  [term]="filter.value"
                ></ngb-highlight>
              </p>


              <div class="activity-meta">

                <div class="meta-item">
                  <span class="meta-label">ID</span>

                  <span class="meta-value activity-id">
                    <ngb-highlight
                      [result]="activity.idActividad"
                      [term]="filter.value"
                    ></ngb-highlight>
                  </span>
                </div>


                <div class="meta-item">
                  <span class="meta-label">Valor</span>

                  <span class="meta-value">
                    {{ activity.valueInHours }} horas
                  </span>
                </div>


                <div class="meta-item participant-meta-item">
                  <span class="meta-label">Cupo</span>
                
                  @if (activity.maxParticipants === null) {
                
                    <span class="meta-value participant-count unlimited">
                      <span class="participant-icon">∞</span>
                
                      {{ activity.participantCount }}
                      {{
                        activity.participantCount === 1
                          ? 'participante'
                          : 'participantes'
                      }}
                
                      <small>· Sin límite</small>
                    </span>
                
                  } @else {
                
                    <span
                      class="meta-value participant-count"
                      [class.full]="isActivityFull(activity)"
                      [class.available]="!isActivityFull(activity)"
                    >
                      <span class="participant-icon">👥</span>
                
                      {{ getParticipantCountLabel(activity) }}
                    </span>
                
                  }
                </div>

                <div class="meta-item">
                  <span class="meta-label">Horario</span>
                
                  @if (activity.startTime && activity.endTime) {
                    <span class="meta-value">
                      {{ activity.startTime }} - {{ activity.endTime }}
                    </span>
                  } @else {
                    <span class="meta-value muted">
                      Horario no especificado
                    </span>
                  }
                </div>

                <div class="meta-item">
                  <span class="meta-label">Enlace</span>

                  @if (activity.url !== "") {

                    <a
                      class="activity-link"
                      [href]="activity.url"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Abrir enlace ↗
                    </a>

                  } @else {

                    <span class="meta-value muted">
                      Sin enlace
                    </span>

                  }

                </div>

              </div>

            </div>


            <!-- ACCIONES -->
            <div class="activity-actions">

              @if (!isAdmin) {
              
                  @switch (getActivityStatus(activity.id)) {
              
                    @case ('registered') {

                      @if (getActivityFolio(activity.id); as regFolio) {

                        <!-- C3.1: inscrito -> píldora Folio AC · Registrado -->
                        <span class="registered-folio-wrapper">
                          <app-folio-pill
                            [folio]="regFolio"
                            [interactionType]="'AC'"
                            [showHours]="false"
                          ></app-folio-pill>

                          <span class="registered-folio-label">
                            · Registrado
                          </span>
                        </span>

                      } @else {

                        <button
                          type="button"
                          class="action-button registered-button"
                          disabled
                        >
                          ✓ Registrado
                        </button>

                      }
              
                      <button
                        type="button"
                        class="action-button cancel-registration-button"
                        (click)="openCancelConfirmation(activity)"
                      >
                        Cancelar registro
                      </button>
              
                    }
              
                    @case ('attended') {
              
                      <button
                        type="button"
                        class="action-button registered-button"
                        disabled
                      >
                        ✓ Asistencia confirmada
                      </button>
              
                    }
              
                    @case ('absent') {
              
                      <button
                        type="button"
                        class="action-button absent-state-button"
                        disabled
                      >
                        ✕ No asistió
                      </button>
              
                    }
              
                    @case ('validated') {
              
                      <button
                        type="button"
                        class="action-button validated-state-button"
                        disabled
                      >
                        ✓ Horas validadas
                      </button>
              
                    }
              
                    @case ('cancelled') {

                      @if (volunteerAccountStatus === 'inactive') {
                    
                        <button
                          type="button"
                          class="action-button inactive-button"
                          disabled
                        >
                          🔒 Cuenta inactiva
                        </button>
                    
                      } @else if (isActivityFull(activity)) {
                    
                        <button
                          type="button"
                          class="action-button full-button"
                          disabled
                        >
                          🔒 Cupo lleno
                        </button>
                    
                      } @else {
                    
                        <button
                          type="button"
                          class="action-button register-button"
                          (click)="registerActivity(activity.id)"
                        >
                          Volver a registrarse
                        </button>
                    
                      }
                    
                    }
              
                    @default {

                      @if (volunteerAccountStatus === 'inactive') {
                    
                        <button
                          type="button"
                          class="action-button inactive-button"
                          disabled
                        >
                          🔒 Cuenta inactiva
                        </button>
                    
                      } @else if (isActivityFull(activity)) {
                    
                        <button
                          type="button"
                          class="action-button full-button"
                          disabled
                        >
                          🔒 Cupo lleno
                        </button>
                    
                      } @else {
                    
                        <button
                          type="button"
                          class="action-button register-button"
                          (click)="registerActivity(activity.id)"
                        >
                          Registrarse
                        </button>
                    
                      }
                    
                    }
              
                  }
              
                

                <button
                  type="button"
                  class="action-button participants-button"
                  (click)="openParticipantsModal(activity)"
                >
                  👥 Ver participantes
                </button>
              
              }


              @if (isAdmin) {

                <button
                  type="button"
                  class="action-button manage-button"
                  (click)="viewParticipants(activity.id)"
                >
                  Ver participantes
                </button>


                <button
                  type="button"
                  class="action-button delete-button"
                  (click)="openDeleteConfirmation(activity)"
                >
                  Eliminar
                </button>

              }

            </div>

          </article>

        } @empty {

          <div class="empty-state">

            <div class="empty-icon">
              !
            </div>

            <h3>No se encontraron actividades</h3>

            <p>
              Intenta cambiar el término de búsqueda.
            </p>

          </div>

        }

      </div>

      <app-pagination
        [(page)]="page"
        [totalItems]="filteredData.length"
        [pageSize]="pageSize"
      ></app-pagination>

    </div>
  }
  </div>


</div>

@if (showDeleteConfirmation && activityToDelete) {

  <div
    class="confirmation-overlay"
    (click)="closeDeleteConfirmation()"
  >

    <div
      class="confirmation-modal"
      (click)="$event.stopPropagation()"
    >

      <div class="confirmation-icon">
        !
      </div>

      <h2>
        ¿Eliminar actividad?
      </h2>

      <p>
        ¿Estás seguro de que deseas eliminar
        <strong>{{ activityToDelete.title }}</strong>?
        Esta acción no se puede deshacer.
      </p>

      <div class="confirmation-actions">

        <button
          type="button"
          class="confirmation-cancel-button"
          [disabled]="isDeleting"
          (click)="closeDeleteConfirmation()"
        >
          Cancelar
        </button>

        <button
          type="button"
          class="confirmation-delete-button"
          [disabled]="isDeleting"
          (click)="confirmDeleteActivity()"
        >
          @if (isDeleting) {
            <span class="delete-loading">
              <span class="delete-spinner"></span>
              Eliminando...
            </span>
          } @else {
            <span>Eliminar actividad</span>
          }
        </button>

      </div>

    </div>

  </div>

}

@if (showCancelConfirmation && activityToCancel) {

  <div
    class="confirmation-overlay"
    (click)="closeCancelConfirmation()"
  >

    <div
      class="confirmation-modal"
      (click)="$event.stopPropagation()"
    >

      <div class="confirmation-icon cancel-registration-icon">
        !
      </div>

      <h2>
        ¿Cancelar registro?
      </h2>

      <p>
        ¿Estás seguro de que deseas cancelar tu registro en
        <strong>{{ activityToCancel.title }}</strong>?
        Podrás volver a registrarte posteriormente si la actividad
        sigue disponible.
      </p>

      <div class="confirmation-actions">

        <button
          type="button"
          class="confirmation-cancel-button"
          [disabled]="isCancelling"
          (click)="closeCancelConfirmation()"
        >
          Volver
        </button>

        <button
          type="button"
          class="confirmation-delete-button"
          [disabled]="isCancelling"
          (click)="confirmCancelRegistration()"
        >
          @if (isCancelling) {
            <span class="delete-loading">
              <span class="delete-spinner"></span>
              Cancelando...
            </span>
          } @else {
            <span>Cancelar registro</span>
          }
        </button>

      </div>

    </div>

  </div>

}

@if (showParticipantsModal && activityForParticipants) {
  <div
    class="confirmation-overlay"
    (click)="closeParticipantsModal()"
  >
    <div
      class="participants-modal"
      (click)="$event.stopPropagation()"
    >
      <div class="participants-modal-header">
        <div>
          <span class="section-eyebrow">Participación</span>
          <h2>Participantes</h2>
          <p>{{ activityForParticipants.title }}</p>
        </div>

        <button
          type="button"
          class="modal-close-button"
          (click)="closeParticipantsModal()"
        >
          ×
        </button>
      </div>

      @if (isLoadingParticipants) {
        <div class="participants-loading">
          <p>Cargando participantes...</p>
        </div>
      } @else if (participants.length > 0) {
        <div class="participants-list">
          @for (student of participants; track student.id) {
            <div class="participant-row">
              <div class="participant-avatar">
                {{ student.fullName.charAt(0) || '?' }}
              </div>
            
              <div class="participant-info">
                <strong>{{ student.fullName || 'Sin nombre' }}</strong>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="empty-participants">
          <h3>Aún no hay participantes</h3>
          <p>Nadie está registrado en esta actividad.</p>
        </div>
      }

      <div class="participants-modal-footer">
        <button
          type="button"
          class="action-button"
          (click)="closeParticipantsModal()"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
}
